// import Login from "../Views/Auth/Login";
import Dashboard from "../Views/Dashboard";
import Individual from "../Views/AdBazar/Individual/index";
import UserDetails from "../Views/AdBazar/Individual/UserDetails";
import ServiceProvider from "../Views/AdBazar/ServiceProvider/index";
import ProviderDetails from "../Views/AdBazar/ServiceProvider/ProviderDetails";
import ServiceSeeker from "../Views/AdBazar/ServiceSeeker/index";
import SeekerDetails from "../Views/AdBazar/ServiceSeeker/SeekerDetails";
import Jobs from "../Views/AdBazar/Jobs/index";
import JobDetails from "../Views/AdBazar/Jobs/JobDetails";
import Proposals from "../Views/AdBazar/Proposals/index";
import ProposalsDetails from "../Views/AdBazar/Proposals/ProposalsDetails";
import Categories from "../Views/AdBazar/Settings/Categories/index";
import Services from "../Views/AdBazar/Settings/Services/index";
import Industries from "../Views/AdBazar/Settings/Industries/index";
import AdLeakCategories from "../Views/AdLeaks/Category";
import CreateAdLeak from "../Views/AdLeaks/Create AdLeak";
import UploadBanner from "../Views/AdLeaks/Upload Banner";
import AdLeakListing from "../Views/AdLeaks/AdLeak Listing";
import UserAdLeakListing from "../Views/AdLeaks/User Adleak Listing";
import EditAdLeak from "../Views/AdLeaks/Edit AdLeak";
import UploadBannerAb from "../Views/AdBazar/Settings/UploadBanner";
import AdMeetListing from "../Views/AdMeet/AdMeet Listing";
import UserAdMeetListing from "../Views/AdMeet/User AdMeet Listing";
import AdMeetCategory from "../Views/AdMeet/Category";
import CreateAdMeet from "../Views/AdMeet/Create AdMeet";
import EditAdMeet from "../Views/AdMeet/Edit AdMeet";
import UploadBannerAm from "../Views/AdMeet/Upload Banner";
import AdBooksListing from "../Views/AdBooks/AdBooks Listing";
import UserAdBookListing from "../Views/AdBooks/User AdBook Listing";
import AdBooksCategory from "../Views/AdBooks/Category";
import CreateAdBook from "../Views/AdBooks/Create AdBook";
import EditAdBook from "../Views/AdBooks/Edit AdBook";
import UploadBannerAdb from "../Views/AdBooks/Upload Banner";
import AdReadListing from "../Views/AdRead/AdRead Listing";
import AdReadCategory from "../Views/AdRead/Category";
import CreateAdRead from "../Views/AdRead/Create AdRead";
import EditAdRead from "../Views/AdRead/EditAdRead";
import UploadBannerAr from "../Views/AdRead/Upload Banner";
import AdGuruListing from "../Views/AdGuru/AdGuru Listing";
import CreateAdGuru from "../Views/AdGuru/Create AdGuru";
import EditAdGuru from "../Views/AdGuru/Edit AdGuru";
import AdGuruCategory from "../Views/AdGuru/Category";
import UploadBannerAdG from "../Views/AdGuru/Upload Banner";
import AdProCategories from "../Views/AdPro/Category";
import AdProListing from "../Views/AdPro/AdPro Listing";
import AdProDetails from "../Views/AdPro/AdPro Listing/AdProDetails";
import UploadHomeBanner from "../Views/Settings/Upload Banner";
import BestOffers from "../Views/Settings/Best Offers";
import FreshLeaks from "../Views/Settings/Fresh Leaks";
import Conversations from "../Views/Conversations";
import Chat from "../Views/Conversations/Chats";
import EscrowAccountLedger from "../Views/Payment";
import Events from "../Views/Events";
import Users from "../Views/Users";
import Banners from "../Views/Settings/Banners";
import WihtdrawRequest from "../Views/WithdrawRequest";
import Onhold from "../Views/Onhold";
import TransactionHistory from "../Views/TransactionHistory";

const AdminRoutes = [
  // {
  //   path: '/login',
  //   component: <Login />
  // },
  {
    path: "/",
    component: <Dashboard />,
  },
  {
    path: "/individual",
    component: <Individual />,
  },
  {
    path: "/service-provider",
    component: <ServiceProvider />,
  },
  {
    path: "/service-seeker",
    component: <ServiceSeeker />,
  },
  {
    path: "/categories",
    component: <Categories />,
  },
  {
    path: "/services",
    component: <Services />,
  },
  {
    path: "/industries",
    component: <Industries />,
  },
  {
    path: "/jobs",
    component: <Jobs />,
  },
  {
    path: "/proposals",
    component: <Proposals />,
  },
  {
    path: "/job-details/:id",
    component: <JobDetails />,
  },
  {
    path: "/user-details/:id",
    component: <UserDetails />,
  },
  {
    path: "/service-provider-details/:id",
    component: <ProviderDetails />,
  },
  {
    path: "/service-seeker-details/:id",
    component: <SeekerDetails />,
  },
  {
    path: "/proposal-details/:id",
    component: <ProposalsDetails />,
  },
  {
    path: "/adleak-list",
    component: <AdLeakListing />,
  },
  {
    path: "/users-adleak-list",
    component: <UserAdLeakListing />,
  },
  {
    path: "/adleak-create",
    component: <CreateAdLeak />,
  },
  {
    path: "/adleak-edit/:id",
    component: <EditAdLeak />,
  },
  {
    path: "/adleak-category",
    component: <AdLeakCategories />,
  },
  {
    path: "/upload-banner-image",
    component: <UploadBanner />,
  },
  {
    path: "/upload-adbazaar-banner-image",
    component: <UploadBannerAb />,
  },
  {
    path: "/admeet-list",
    component: <AdMeetListing />,
  },
  {
    path: "/users-admeet-list",
    component: <UserAdMeetListing />,
  },
  {
    path: "/admeet-create",
    component: <CreateAdMeet />,
  },
  {
    path: "/admeet-edit/:id",
    component: <EditAdMeet />,
  },
  {
    path: "/admeet-category",
    component: <AdMeetCategory />,
  },
  {
    path: "/upload-admeet-banner-image",
    component: <UploadBannerAm />,
  },
  {
    path: "/adbooks-list",
    component: <AdBooksListing />,
  },
  {
    path: "/users-adbook-list",
    component: <UserAdBookListing />,
  },
  {
    path: "/adbook-create",
    component: <CreateAdBook />,
  },
  {
    path: "/adbook-edit/:id",
    component: <EditAdBook />,
  },
  {
    path: "/adbook-category",
    component: <AdBooksCategory />,
  },
  {
    path: "/upload-adbooks-banner-image",
    component: <UploadBannerAdb />,
  },
  {
    path: "/adread-list",
    component: <AdReadListing />,
  },
  {
    path: "/adread-create",
    component: <CreateAdRead />,
  },
  {
    path: "/adread-edit/:id",
    component: <EditAdRead />,
  },
  {
    path: "/adread-category",
    component: <AdReadCategory />,
  },
  {
    path: "/upload-adread-banner-image",
    component: <UploadBannerAr />,
  },
  {
    path: "/adguru-list",
    component: <AdGuruListing />,
  },
  {
    path: "/adguru-create",
    component: <CreateAdGuru />,
  },
  {
    path: "/adguru-edit/:id",
    component: <EditAdGuru />,
  },
  {
    path: "/adguru-category",
    component: <AdGuruCategory />,
  },
  {
    path: "/upload-adguru-banner-image",
    component: <UploadBannerAdG />,
  },
  {
    path: "/adpro-list",
    component: <AdProListing />,
  },
  {
    path: "/adpro-services",
    component: <AdProCategories />,
  },
  {
    path: "/adpro-details/:id",
    component: <AdProDetails />,
  },
  {
    path: "/upload-adpro-banner-image",
    component: <UploadBannerAdG />,
  },
  {
    path: "/upload-home-banner-image",
    component: <UploadHomeBanner />,
  },
  {
    path: "/best-offers",
    component: <BestOffers />,
  },
  {
    path: "/fresh-leaks",
    component: <FreshLeaks />,
  },
  {
    path: "/conversations",
    component: <Conversations />,
  },
  {
    path: "/chat/:id",
    component: <Chat />,
  },
  {
    path: "/escrow-accounts",
    component: <EscrowAccountLedger />,
  },
  {
    path: "/events",
    component: <Events />,
  },
  {
    path: "/email-users",
    component: <Users />,
  },
  {
    path: "/banners",
    component: <Banners />,
  },
  {
    path: "/withdraw-request",
    component: <WihtdrawRequest />,
  },
  {
    path: "/on-hold",
    component: <Onhold />,
  },
  {
    path: "/transaction-history",
    component: <TransactionHistory />,
  },
];

export default AdminRoutes;
